import React from 'react';
import PropTypes from 'prop-types';

import Btn from '../../atoms/btn';

class HotelPolicies extends React.Component {
  render() {
    const { hotel, lang } = this.props;
    const hotelPolicies = `/policies/${hotel.pk}/${lang}/`;
    return (
      <Btn href={hotelPolicies} icon="file" iconClassName="text-primary" className="py-1">
       {this.context.t('view policies')}
      </Btn>
    );
  }
}

HotelPolicies.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default HotelPolicies;
